import { getMessages } from '../../../../../../store/constants';

export const BOARD_TOOLTIP = getMessages().getText('card_form_board_tooltip');
export const RELATED_CARD_DELETE_TOOLTIP = getMessages().getText('card_form_delete_related_card');
